/** True when the user must supply a real API origin (missing, templated, or placeholder). */
export function needsBaseUrlOverride(baseUrl: string | undefined | null): boolean {
  const url = (baseUrl ?? "").trim();
  if (!url) return true;
  if (/\{[^}]+\}/.test(url)) return true;
  if (/your-domain|your-?company|example\.com|api\.example/i.test(url)) return true;
  return false;
}

const FALLBACK_BASE_URL_PLACEHOLDER = "https://api.example.com";

/**
 * Placeholder for the base URL input when the spec lists a template/placeholder server URL.
 * Uses the spec value when present so Jira, Stripe, etc. each show their own example.
 */
export function baseUrlInputPlaceholder(specBaseUrl: string | undefined | null): string {
  const fromSpec = (specBaseUrl ?? "").trim();
  if (fromSpec) return fromSpec;
  return FALLBACK_BASE_URL_PLACEHOLDER;
}
